import { render, staticRenderFns } from "./BulkActionsTable.vue?vue&type=template&id=2b6894ce&scoped=true&"
import script from "./BulkActionsTable.vue?vue&type=script&lang=ts&"
export * from "./BulkActionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./BulkActionsTable.vue?vue&type=style&index=0&id=2b6894ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6894ce",
  null
  
)

export default component.exports